export interface NFDNormalizeOptions {
  /** Lowercase both strings before comparing (case-insensitive match). Default: true. */
  caseInsensitive?: boolean;
  /**
   * Drop every non-alphanumeric character (punctuation, spaces, special chars)
   * after stripping accents. Use for numeric/phone matching where formatting like
   * "(11) 99999" should match a raw "1199999". Default: false (preserve them).
   */
  stripNonAlphanumeric?: boolean;
}

export const DEFAULT_NFD_OPTIONS: Required<NFDNormalizeOptions> = {
  caseInsensitive: true,
  stripNonAlphanumeric: false,
};

/**
 * Strips NFD combining diacritical marks (accents). By default punctuation,
 * special characters, numbers and spaces are preserved; casing is preserved
 * unless `caseInsensitive` is set. With `stripNonAlphanumeric`, all
 * non-alphanumeric characters are also removed.
 */
function normalizeNFD(str: string, opts: Required<NFDNormalizeOptions>): string {
  let out = str.normalize('NFD').replace(/[̀-ͯ]/g, '');
  if (opts.stripNonAlphanumeric) out = out.replace(/[^\p{L}\p{N}]/gu, '');
  if (opts.caseInsensitive) out = out.toLowerCase();
  return out;
}

/**
 * Accent-insensitive substring check. Both arguments are NFD-normalized (accents
 * removed, everything else preserved) before testing whether `searchingIn`
 * contains `searchingFor`.
 *
 * @example StrContainsNFDNormalized('jose', 'José Silva') // true
 */
export function StrContainsNFDNormalized(
  searchingFor: string,
  searchingIn: string,
  options: NFDNormalizeOptions = {},
): boolean {
  const opts = { ...DEFAULT_NFD_OPTIONS, ...options };
  // console.log(`StrContainsNFDNormalized`, normalizeNFD(searchingIn, opts).includes(normalizeNFD(searchingFor, opts)), normalizeNFD(searchingIn, opts), normalizeNFD(searchingFor, opts))
  return normalizeNFD(searchingIn, opts).includes(normalizeNFD(searchingFor, opts));
}
